import { displayNameAsLastCommaFirst } from 'shared';

export const displayAthleteName = (
    athlete: { jersey?: string; last_name?: string; first_name?: string },
    includeJersey = false,
) =>
    (includeJersey ? `${athlete.jersey}. ` : '') +
    `${displayNameAsLastCommaFirst(athlete.last_name || '', athlete.first_name || '', false, true)}`;
